<template>
    <div v-if="componentData" class="wrapper ThreeColumnCards">
        <h2 v-if="componentData.threeColumnCardsTitle">
            {{componentData.threeColumnCardsTitle}}
        </h2>
        <div class="grid three">
            <div class="card__block" v-for="(block, index) in componentData.blocks" :key="index">
                <div class="index__holder">
                    0{{index+1}}
                </div>
                <div class="card__block__content">
                    <h3 v-if="block.title">{{block.title}}</h3>
                    <p v-if="block.description">{{block.description}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
